import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { Clear } from "@material-ui/icons";

type propsType = {
  onPressEnter: (word: string) => void;
  onClickClear: () => void;
};

const SearchInputBox = ({ onPressEnter, onClickClear }: propsType) => {
  const [searchWord, setSearchWord] = useState("");

  const onKeyup = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key !== "Enter" || !searchWord.trim()) return;

    onPressEnter(searchWord);
  };

  const onClick = () => {
    setSearchWord("");
    onClickClear();
  };

  return (
    <Box component="div" sx={{ p: 2, position: "relative" }}>
      <TextField
        fullWidth
        id="outlined-basic"
        label="검색어 입력"
        variant="outlined"
        onKeyUp={onKeyup}
        value={searchWord}
        autoFocus={true}
        onChange={(event) => {
          setSearchWord(event.target.value);
        }}
      />
      <Clear
        style={{
          position: "absolute",
          bottom: "37%",
          right: "25",
          cursor: "pointer",
        }}
        onClick={onClick}
      />
    </Box>
  );
};

export default SearchInputBox;
